/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Company
 */
export interface Company {
  /**
   *
   * @type {number}
   * @memberof Company
   */
  companyId?: number;
  /**
   *
   * @type {number}
   * @memberof Company
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  key: string;
  /**
   *
   * @type {string | null}
   * @memberof Company
   */
  name?: string | null;
}

/**
 * Check if a given object implements the Company interface.
 */
export function instanceOfCompany(value: object): value is Company {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function CompanyFromJSON(json: any): Company {
  return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Company {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'] == null ? undefined : json['company_id'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    id: json['id'],
    key: json['key'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function CompanyToJSON(value?: Company | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    id: value['id'],
    key: value['key'],
    name: value['name'],
  };
}
